<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name, spacing]"
    :style="mainCssVars"
  >
    <m-slide-v2 :cms="cms" />
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import data from '~/components/organisms/o-hero-image/o-hero-image.data'
import MSlideV2 from '~/components/molecules/m-slide/m-slide-v2'

export default {
  components: { MSlideV2 },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
    layout: {
      type: Array,
      default() {
        return [{ size: 0, bound: 313, ratio: [162, 163] }]
      },
    },
  },

  data() {
    return {
      name: 'o-hero-image',
    }
  },

  computed: {
    spacing() {
      return this.cms.spacing
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#000000',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#FFFFFF'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--filter': this.cms.filter || null,
      }
    },
  },
  methods: {
    gridClass(copy) {
      return copy ? `${this.name}__item--large` : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-hero-image {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  display: grid;
  // align-content: center;
  height: calc(100vh - 73px);
  min-height: 693px;
  max-height: 820px;

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  ::v-deep img {
    filter: var(--filter);
  }
}

@include media-breakpoint-up(md) {
  .o-hero-image {
    ::v-deep .m-carousel-slide {
      &__heading {
        @include font-family($headings-font-family, 600);
        @include font-size(83, 96px);

        max-width: initial;
      }
    }
  }
}
</style>
